import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function updateExistingFastStockLoadingData(id,saveData) {
  const response = await axios.put(
    `${CATALOGO_ENDPOINT}/${id}?fast_stock_loading=true`,
    {...saveData}
  )
  return response.data
}